(function ($, SCS, debug) {
	'use strict';

	/**
	 * Create namespaces
	 */
	SCS.TV = SCS.TV || {};

	/**
	 * Broadcast Class
	 */
	function Broadcast(broadcastId, callback) {
		this._init(broadcastId, callback);
	}

	// poster url - using resizing servlet and the closest image size available from the service
	Broadcast.posterUrl = (SCS.Const.SNOOPY_IMAGE_BASE ? SCS.Const.SNOOPY_IMAGE_BASE + '/{width}x0/' : SCS.Const.SNOOPY_SERVICE_PROXY_URL) + 'content/images/tv/broadcast/{broadcastid}_poster_{size}.jpg';

	// static functions
	Broadcast.getPosterUrlByBroadcastId = function (broadcastId, width) {
		var availableWidth = SCS.TV.Helper.getBestImageWidth(width);
		return Broadcast.posterUrl.replace('{broadcastid}', broadcastId).replace('{size}', 'W' + availableWidth).replace('{width}', width);
	};

	Broadcast.getPlayerUrl = function(broadcastId) {
		return SCS.Const.SNOOPY_SHARING_URL + 'L=' + SCS.Const.SNOOPY_LANGUAGE + '&T=Watch&I=' + broadcastId;
	};

	Broadcast.getDetailsUrl = function(broadcastId) {
		return SCS.Const.SNOOPY_SHARING_URL + 'L=' + SCS.Const.SNOOPY_LANGUAGE + '&T=Program&I=' + broadcastId;
	};


	Broadcast.prototype = {
		constructor: Broadcast,
		_init: function (broadcastId, callback) {
			this.broadcastId = broadcastId;
			this.title = '';
			this.summary = '';
			this.duration = '';
			this.language = '';
			this.start = new Date(2000,1,1);
			this.end = new Date(2000,1,1);
			this.price = 0;
			this.currency = 'CHF';
			this.channelId = '';
			if (broadcastId) { // do not initialize if no id is given
				this._loadData(callback);
			}
		},

		_loadData: function (callback) {
			var broadcast = this;
			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/tv/broadcasts/list/(datalevel=normal;ids=' + this.broadcastId + ');', function (data) {
				debug.log('SCS.TV > Broadcast > read free tv data', data);

				if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0) {
					var broadcastInfo = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(data.Nodes.Items, 'Broadcast');

					broadcast._readData(broadcastInfo);
				}

				if (typeof callback === 'function') {
					callback(broadcast);
				}
			});
		},

		/**
		 * Public API
		 */
		getPosterUrl: function (width) {
			var availableWidth = SCS.TV.Helper.getBestImageWidth(width);
			return this.posterUrl.replace('{size}', 'W' + availableWidth).replace('{width}', width);
		},

		/**
		 * Public API
		 */
		getChannel: function (callback) {
			if (this.channelId !== '') {
				return new SCS.TV.Channel(this.channelId, callback);
			}
			return null;
		},

		getPlayerUrl: function () {
			return SCS.TV.Broadcast.getPlayerUrl(this.broadcastId);
		},

		getDetailsUrl: function() {
			return SCS.TV.Broadcast.getDetailsUrl(this.broadcastId);
		},

		getFormattedPrice: function () {
			return SCS.utils.formatPrice(this.price);
		},

		isToday: function () {
			return SCS.TV.Helper.isToday(this.start);
		},

		isTomorrow: function () {
			return SCS.TV.Helper.isTomorrow(this.start);
		},

		_readData: function (broadcastInfo) {
			if (broadcastInfo) {
				if (broadcastInfo.Content && broadcastInfo.Content.Description) {
					this.title = broadcastInfo.Content.Description.Title;
					var durationString = broadcastInfo.Content.Description.Duration;
					if (durationString) {
						var durationParts = durationString.split(':');
						if (durationParts.length === 3) {
							this.duration = 60*parseInt(durationParts[0], 10) + parseInt(durationParts[1], 10);
						}
					}
					this.summary = broadcastInfo.Content.Description.Summary ? broadcastInfo.Content.Description.Summary : '';
					this.language = broadcastInfo.Content.Description.Language;
				}
				if (broadcastInfo.Availabilities && broadcastInfo.Availabilities.length > 0) {
					if (SCS.Const.SNOOPY_IS_OLD_IE) {
						this.start = SCS.TV.Helper.readDateIE8(broadcastInfo.Availabilities[0].AvailabilityStart);
						this.end = SCS.TV.Helper.readDateIE8(broadcastInfo.Availabilities[0].AvailabilityEnd);
					}
					else {
						this.start = new Date(broadcastInfo.Availabilities[0].AvailabilityStart);
						this.end = new Date(broadcastInfo.Availabilities[0].AvailabilityEnd);
					}

					if (!this.duration) {
						var diffMs = (this.end - this.start); // milliseconds between start and end
						this.duration = Math.round(diffMs / 60000);
					}

					this.price = broadcastInfo.Availabilities[0].Price ? parseFloat(broadcastInfo.Availabilities[0].Price) : 0;
					if (this.price > 0) { // web users pay 2.- more to rent the stream
						this.price += SCS.Const.SNOOPY_WEB_RENT_SURCHARGE;
					}
					this.currency = broadcastInfo.Availabilities[0].Currency;
				}
				if (broadcastInfo.Relations) {
					var tempChannel = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(broadcastInfo.Relations, 'Reference', 'ChannelIdentifier');
					this.channelId = tempChannel ? tempChannel.TargetIdentifier : '';
				}

				// write id-specific data here in case the object was created without ID and loaded by reading already loaded data using _readData
				this.broadcastId = broadcastInfo.Identifier;
				this.posterUrl = Broadcast.posterUrl.replace('{broadcastid}', this.broadcastId);
			}
		}
	};

	SCS.TV.Broadcast = Broadcast;

}(window.jQuery, window.SCS = window.SCS || {}, window.debug));



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/tv/SCS.TV.Broadcast.js
// module id = 88
// module chunks = 0